import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '@/components/img/sad.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "margin-auto-rl",
  id: "sad_face",
  src: _imports_0,
  alt: "Sad face",
  style: {"height":"100px","margin-bottom":"16px"}
}, null, -1)
const _hoisted_4 = {
  class: "margin-auto-rl",
  style: {"text-align":"center"}
}
const _hoisted_5 = {
  class: "margin-auto-rl",
  style: {"text-align":"center"}
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("a", {
  class: "margin-auto-rl",
  href: "mailto:hello@makewise.vision"
}, " hello@makewise.vision ", -1)

import { IonImg, IonItem, IonList } from '@ionic/vue';
import { Storage } from '@ionic/storage';
import { ProcessResult } from 'plate-vision-demo-openapi-client';
import { onMounted, ref } from 'vue';
import TrustBar from '@/components/trust-bar.vue';
import vehiclesFound from '@/components/vehicles-found.vue';
import ReturnButton from '@/components/returnButton.vue';
import { useI18n } from 'vue-i18n';

interface FinalReport {
    response: ProcessResult;
    date: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ReportPage',
  props: {
    index: null
  },
  setup(__props: any) {

const props = __props as {
    index: string;
};

const { t } = useI18n({
    inheritLocale: true,
    useScope: 'global',
});

const storage = new Storage();
const report = ref<ProcessResult | undefined>();
const pageLoaded = ref<boolean>(false);

onMounted(() => {
    storage.create().then(() => {
        storage.get('reports').then((reportArray: FinalReport[]) => {
            report.value = reportArray[parseInt(props.index)].response;
            pageLoaded.value = true;
        });
    });
});




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (report.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_unref(IonList), {
            class: "bradius12",
            lines: "full"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonItem), null, {
                default: _withCtx(() => [
                  _createElementVNode("h3", null, _toDisplayString(_unref(t)('imageDetails')), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(IonItem), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonImg), {
                    class: "bradius12 margin-auto-rl margin-1-rem-tb",
                    src: 'data:' + report.value.processedImageMimeType + ';base64,' + report.value.processedImage
                  }, null, 8, ["src"])
                ]),
                _: 1
              }),
              _createVNode(_unref(IonItem), { class: "reportSubtitle" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('width')) + ": " + _toDisplayString(report.value.imgWidth) + " px ", 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(IonItem), { class: "reportSubtitle" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('height')) + ": " + _toDisplayString(report.value.imgHeight) + " px ", 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(IonItem), { class: "reportSubtitle" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('type')) + ": " + _toDisplayString(report.value.imgType), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(IonItem), { class: "reportSubtitle" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('quality')) + ": " + _toDisplayString(report.value.imgQuality) + "/10 ", 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(IonItem), { class: "ion-align-items-start" }, {
                default: _withCtx(() => [
                  _createVNode(TrustBar, {
                    maxTrust: 10,
                    reportTrust: report.value.imgQuality
                  }, null, 8, ["reportTrust"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _hoisted_1,
          (report.value.results.length > 0)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(report.value.results, (vehicle, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: vehicle }, [
                  (index > 0)
                    ? (_openBlock(), _createElementBlock("br", _hoisted_2))
                    : _createCommentVNode("", true),
                  _createVNode(_unref(IonList), { class: "bradius12" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonItem), null, {
                        default: _withCtx(() => [
                          _createElementVNode("h4", null, _toDisplayString(_unref(t)('vehiclesFound')) + " - " + _toDisplayString(index + 1) + " / " + _toDisplayString(report.value.results.length), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(vehiclesFound, {
                        totalVehicles: report.value.results.length,
                        processedImageMimeType: report.value.processedImageMimeType,
                        displayDemoResult: vehicle
                      }, null, 8, ["totalVehicles", "processedImageMimeType", "displayDemoResult"])
                    ]),
                    _: 2
                  }, 1024)
                ], 64))
              }), 128))
            : (_openBlock(), _createBlock(_unref(IonList), {
                key: 1,
                class: "bradius12",
                style: {"padding":"24px 0"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonItem), { style: {"width":"100%"} }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonItem), null, {
                    default: _withCtx(() => [
                      _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)('reportPage.noVehiclesDetected')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonItem), null, {
                    default: _withCtx(() => [
                      _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)('reportPage.contactUs')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonItem), null, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
        ], 64))
      : (pageLoaded.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode(_toDisplayString(_unref(t)('reportPage.errorLoading')), 1)
          ], 64))
        : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createVNode(ReturnButton, { style: {"margin-top":"1rem"} })
    ])
  ], 64))
}
}

})